import { apiClient } from "../core/apiClient";

interface results<T = any> {
  data: T
}

interface params {
  user_id?: string,
  start_date?: string,
  end_date?: string,
}

export class ReportsService {
  async getConversionLeads(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/conversion-metrics${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }



  async getLeadsBySource(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/leads-by-source${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

  async getReportsLeads(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `?${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/leads/by-process-status${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

  async getReportsActivities(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/leads/by-activities${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

  async getReportsPrograms(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/leads/by-program${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

  async getReportsStatus(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/leads/by-status${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }



















  async getConversionDeals(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/deals/conversion-metrics${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }


  async getReportsStatusDeals(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/deals/by-status${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

  async getDealsBySource(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/deals-by-source${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

  async getReportsActivitiesDeals(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/deals/by-activities${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }

  async getReportsDeals(params?: params): Promise<results> {
    const validParams = params
      ? Object.fromEntries(
        Object.entries(params).filter(([_, v]) =>
          v !== undefined && v !== null && v !== ''
        )
      )
      : {};

    const queryString = Object.keys(validParams).length > 0
      ? `?${new URLSearchParams(validParams as any).toString()}`
      : '';

    const endpoint = `/reports/deals/by-process-status${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get<results>(endpoint);
    return response;
  }
}

export const reportsService = new ReportsService();